// Shared relative-time formatter. Several queue surfaces (dashboard,
// escalation list, R-162 operator roster) and the R-274 7d Pending Release
// page render a coarse "Xm/h/d ago" label off an ISO timestamp; this is the
// one implementation they should share.
export function timeAgo(iso: string): string {
  const diff = Date.now() - new Date(iso).getTime();
  const mins = Math.floor(diff / 60_000);
  if (mins < 1) return "just now";
  if (mins < 60) return `${mins}m ago`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  return `${days}d ago`;
}
